module.exports = __webpack_public_path__ + "72d44f66a99502cb203aa13af8e8e18a.png";